import { required, maxLength, range, nested } from '@rx/annotations';
import { ProjectModule, ArrivalAndOpeningTactic, EventAgendaTiming,  vProjectEventTimelineRecord, TheirTeamCommunicationMode  } from './'
import { NegotiationTimelineCommunicationMode } from './negotiation-timeline-communication-mode';
export class ProjectEventTimeline {
    constructor(projectEventTimeline?: ProjectEventTimeline  | vProjectEventTimelineRecord )  {
        let properties = [ "endTime", "eventDuration", "isEndTimeFixed", "openingStatement", "projectEventTimelineId", "roomLayout", "startTime", "projectModuleId", "arrivalAndOpeningTactics", "eventAgendaTimings","eventName","eventTimingKnown"];
        for (let property of properties)
            if (projectEventTimeline && projectEventTimeline[property])
                this[property] = projectEventTimeline[property];
    }

    @required()
	endTime : Date =   undefined;

    @required()
    @maxLength(10)
	eventDuration : string =   undefined;

	isEndTimeFixed : boolean = false ;

    @required()
    @maxLength(200)
	openingStatement : string =   undefined;

	projectEventTimelineId : number =   0 ;

    @required()
    @maxLength(350)
	roomLayout : string =   undefined;

    @required()
	startTime : Date =   undefined;

    @required()
	eventName : string =   undefined;

    
	eventTimingKnown : boolean =true;

    @range(0,2147483647)
	projectModuleId : number =   undefined;
	projectModule : ProjectModule  ;
	
    @nested(ArrivalAndOpeningTactic)
	arrivalAndOpeningTactics: ArrivalAndOpeningTactic[];

	@nested(EventAgendaTiming)
	eventAgendaTimings: EventAgendaTiming[];

	@nested(NegotiationTimelineCommunicationMode)
	negotiationTimelineCommunicationModes: NegotiationTimelineCommunicationMode[];

}



// WEBPACK FOOTER //
// ./src/app/database-models/project-event-timeline.ts